export const persistImageSizing = (html) => {
  try {
    if (!html || (!html.includes("data-width") && !html.includes("data-align"))) return html;

    const doc = new DOMParser().parseFromString(html, "text/html");
    const imgs = doc.querySelectorAll("img[data-width], img[data-align]");

    imgs.forEach((img) => {
      const width = img.getAttribute("data-width") || "100";
      const align = img.getAttribute("data-align") || "center";

      const w = Math.max(10, Math.min(100, Number(width)));

      let marginLeft = "auto";
      let marginRight = "auto";
      if (align === "left") {
        marginLeft = "0";
        marginRight = "auto";
      } else if (align === "right") {
        marginLeft = "auto";
        marginRight = "0";
      }

      const style = [
        img.getAttribute("style") || "",
        "display:block",
        `width:${w}%`,
        "max-width:100%",
        "height:auto",
        `margin-left:${marginLeft}`,
        `margin-right:${marginRight}`,
      ]
        .filter(Boolean)
        .join(";");

      img.setAttribute("style", style);
    });

    return doc.body.innerHTML;
  } catch {
    return html;
  }
};

export const sanitizeEmptyFontStyles = (html) => {
  try {
    if (!html || (!html.includes("font-size") && !html.includes("font-family"))) return html;

    const doc = new DOMParser().parseFromString(html, "text/html");
    const styledNodes = doc.querySelectorAll("[style]");

    styledNodes.forEach((node) => {
      const style = node.getAttribute("style");
      if (!style || (!style.includes("font-size") && !style.includes("font-family"))) return;

      const cleanedDeclarations = style
        .split(";")
        .map((declaration) => declaration.trim())
        .filter(Boolean)
        .filter((declaration) => {
          const separatorIdx = declaration.indexOf(":");
          if (separatorIdx === -1) return true;

          const property = declaration.slice(0, separatorIdx).trim().toLowerCase();
          const value = declaration.slice(separatorIdx + 1).trim();

          if ((property === "font-size" || property === "font-family") && !value) return false;
          return true;
        });

      if (cleanedDeclarations.length === 0) {
        node.removeAttribute("style");
        return;
      }

      node.setAttribute("style", cleanedDeclarations.join("; "));
    });

    return doc.body.innerHTML;
  } catch {
    return html;
  }
};

export const normalizeHtml = (html) =>
  sanitizeEmptyFontStyles(persistImageSizing((html || "").trim()));
